module.exports = __webpack_public_path__ + "img/gb83.prt.de5ae257.jpg";